import React from "react";
import SynchronizedChartItem from "./SynchronizedChartItem";
import { PRESENT, PREVIOS_PERIOD } from "../AnalyticsConstants";

type SynchronizedChartsProps = { data: { name: string; data: { x: string; y: number | null; }[]; }[]; dashedArray?: [], metricName?: string, xAxis?: string[], granularity?: string, timezone: string }

const SynchronizedCharts = React.memo(({ data, metricName, xAxis, granularity, timezone } : SynchronizedChartsProps) => {
    const getAxis = (chartData: any) => {
        return xAxis?.filter((date: any) => {
            const currentDate = new Date(date);
            return chartData?.some((item: any) => {
                const itemDate = new Date(item.x);
                return itemDate.getTime() === currentDate.getTime();
            });
        });
    }

    return (
        <div >
            {data && data[1]?.data.length !== 0 ? 
                <SynchronizedChartItem
                    id={PREVIOS_PERIOD}
                    type="line"
                    metricName={metricName}
                    granularity={granularity}
                    xAxis={getAxis(data && data[1]?.data)}
                    data={data[1]}
                    timezone={timezone}
                />
            : null}
            {data && data[0]?.data.length !== 0 ?
                <SynchronizedChartItem
                    id={PRESENT}
                    type="line"
                    metricName={metricName}
                    granularity={granularity}
                    xAxis={getAxis(data && data[0]?.data)}
                    data={data[0]}
                    timezone={timezone}
                />
            : null}
        </div>
    );
});


export default SynchronizedCharts;